import React from 'react';
import { ListLoading } from './ListLoading';

type EmptyStateProps = {
  title: string;
  description: string;
  isLoading?: boolean;
};

const EmptyState: React.FC<EmptyStateProps> = ({ title, description, isLoading = false }) => {
  return (
    <div className="m-20 text-center">
      {isLoading ? (
        <ListLoading />
      ) : (
        <>
          <img src="/media/buttons/emptystate.svg" alt="" />
          <div className="m-5 fs-5">
            <p style={{ fontWeight: 'bold' }}>{title}</p>
          </div>
          <p>{description}</p>
        </>
      )}
    </div>
  );
};

export default EmptyState;